import React from 'react'
import {Spin} from 'antd'
import classNames from 'classnames'

import styles from './GlobalLoader.scss'

interface GlobalLoaderProps {
    isLoading: boolean
    className?: string
}

export const GlobalLoader: React.FC<GlobalLoaderProps> = ({isLoading, className}) => {
    if (!isLoading) return null

    return (
        <div className={classNames(styles.globalLoader, className)}>
            <div className={styles.backdrop} />
            <div className={styles.spinContainer}>
                <Spin size="large" />
            </div>
        </div>
    )
}